export default "__VITE_ASSET__BcTb3DZS__"